
import { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import classNames from "classnames";
import Coin_exchange from "./coin_exchange";
import Coin_option from "./coin_option";
import Coin_seller_home from "./coin_seller_home";
import Coin_partner_home from "./coin_partner_home";
import Tabs_nav from "../../app_structure/tabs_nav/tabs_home.jsx";
import Options from "../../shop/ai/options.jsx";

const Coin_home = () => {
    const { slug_1 } = useParams();
    return (
        <>
            <Tabs_nav category={'wallet_seller'} />
            {slug_1 === "coins" && (
                <Options />
            )}
            {slug_1 === "partner" && (
                <Coin_partner_home />
            )}
            {slug_1 === "exchange" && (
                <Coin_exchange />
            )}
            {slug_1 === "seller" && (
                <Coin_seller_home />
            )}
        </>
    );
}

export default Coin_home;
